import Box from 'components/Box';
import { DropDownOptions } from 'models/report';
import Dropdown from 'components/Input/dropdown/Dropdown';
import { InputContainer } from '../styles';
import React from 'react';
import styled from 'styled-components/macro';
import utils from 'utils';
import { InputLabel } from 'routes/Configurator/styles';

const InputContainerStyled = styled(InputContainer)`
  justify-content: center;
`;

interface Props {
  onChangeFolder: (e: DropDownOptions) => void;
  onChangeReport: (e: DropDownOptions) => void;
  selectedFolder: DropDownOptions;
  selectedReport: DropDownOptions;
  optionsFolder: DropDownOptions[];
  optionsReport: DropDownOptions[];
  disabled?: boolean;
}

export default (props: Props) => {
  const { onChangeFolder, selectedFolder, onChangeReport, selectedReport, optionsFolder, optionsReport, disabled } =
    props;
  const t = utils.intl.useTranslator();
  const closeMenuOnScroll = (event: any) => {
    if (event.target instanceof Document) {
      const activeElement = event.target.activeElement;
      if (activeElement?.id?.includes('react-select')) return false;
      return true;
    }
    if (event.target instanceof HTMLElement) {
      if (event.target?.className?.includes('MenuList') || event.target.parentElement?.className?.includes('menu')) {
        return false;
      }
      return true;
    }
    return true;
  };

  return (
    <Box title={t('report-select-report')}>
      <div>
        <InputContainerStyled>
          <InputLabel>{t('report-label-folder')}</InputLabel>
          <Dropdown
            id="folder-dropdown"
            value={selectedFolder}
            onChange={onChangeFolder}
            name="folder"
            options={optionsFolder}
            closeMenuOnScroll={closeMenuOnScroll}
            disabled={disabled}
            width="200px"
          />
        </InputContainerStyled>
        <InputContainerStyled padding="0px">
          <InputLabel>{t('report-label-report')}</InputLabel>
          <Dropdown
            id="report-dropdown"
            value={selectedReport}
            onChange={onChangeReport}
            name="report"
            options={optionsReport}
            closeMenuOnScroll={closeMenuOnScroll}
            disabled={disabled}
            width="200px"
          />
        </InputContainerStyled>
      </div>
    </Box>
  );
};
